<template>
    <el-dialog
            :visible.sync="dialogVisible"
            width="750px"
            height="75%"
            :show-close="false"
            :before-close="handleClose"
            class="a_modal"
            style="vertical-align: center;: #FFF9F3">
        <div style="margin-top: -30px; ">

            <el-row>
                <el-col :span="12">
                    <span style="color: cornflowerblue; font-size: 18px">服务项目</span>
                </el-col>
                <el-col :span="12">
                    <div align="right" style="margin-top:  -5px">
                        <el-row>
                            <el-button type="danger" size="small"
                                       @click.stop="dialogVisible=false">关闭
                            </el-button>
                        </el-row>
                        <!--<el-row v-else-if="thirdForm.type == 'ADD'">-->

                        <!--<el-row>-->
                            <!--<el-button type="success" size="small"-->
                                       <!--@click.stop="addthirdFormItem">确定-->
                            <!--</el-button>-->
                            <!--<el-button type="danger" size="small"-->
                                       <!--@click.stop="dialogVisible=false">取消-->
                            <!--</el-button>-->
                        <!--</el-row>-->
                    </div>
                </el-col>
            </el-row>

            <div style="width: 100%; height: 0px; margin-top: 15px;border:1px dashed gainsboro"></div>

            <div style="margin-top: 20px">
                <el-form ref="form3" :model="form" label-width="10%">
                    <el-form-item label="项目">
                        <el-input placeholder="请输入内容" v-model="form.service_item" disabled
                                  clearable></el-input>

                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input type="number" placeholder="请输入数量" v-model="form.number" disabled
                                  clearable></el-input>

                    </el-form-item>
                    <el-form-item label="说明">
                        <el-input placeholder="请输入内容" v-model="form.comments"  disabled clearable></el-input>

                    </el-form-item>


                </el-form>

            </div>

        </div>

    </el-dialog>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
//            form: {
//                type: Object,
//                default: () => {
//
//                }
//
//            },
//            dialogVisible: {
//                type: Boolean,
//                default: false
//            },
//            type: {
//                type: String,
//                default: 'SHOW'
//            },

        },
        components: {
        },
            data() {
            return {

                dialogVisible: false,

                form: {
                    service_item: '',
                    number: '',
                    comments: '',
                },
            }
        },
        computed: {

        },
        created() {
//            this.getAccountData()
//            this.getServiceTypeData()
        },
        methods: {

            addthirdFormItem() {
                var obj = {}
                obj.service_item = this.form3.service_item
                this.form.service_item = ''
                obj.number = this.form3.number
                this.form.number = ''
                obj.comments = this.form3.comments
                this.form.comments = ''
                this.dialogVisible = false
                this.$emit('addthirdFormItem', obj)
            },
            getValue(row) {

            },
            showDialog(row) {
//                this.form.title = ""
//                this.form.date = ""
//                this.form.ticketNo = ""
//                this.form.worker = ""
//                this.form.comments = ""
//                this.form.phone = ""
//                this.form.store = ""
//                this.form.category = ""
//                this.form.account = ""
//                this.form.count_down = "60"
//                this.fileList = []
//                this.form.picArray = []


                this.form.service_item = row.service_item
                this.form.comments = row.comments
                this.form.number = row.number
                this.dialogVisible = true

//                this.thirdForm.dialogVisible = true
//                this.thirdForm.type = 'SHOW'
            },

//            info(index, row) {
//                this.$router.push({
//                    path: '/workOrderInfo',
////                    query: {
////                        type: 1,
////                        ticket_id: row.ticket_id,
////                        store_name: row.store_name,
////                        address: row.address
////                    }
//                })
//            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            enterClick() {

                if (this.form.title.replace(/\s*/g, "") == "") {
                    this.$message.error('请输入标题');
                    return
                }
                if (this.form.date == "") {
                    this.$message.error('请选择发生日期');
                    return
                }
                if (this.form.ticketNo.replace(/\s*/g, "") == "") {
                    this.$message.error('请生成单号');
                    return
                }
                if (this.form.account.replace(/\s*/g, "") == "") {
                    this.$message.error('请选择客户');
                    return
                }
                if (this.form.store.replace(/\s*/g, "") == "") {
                    this.$message.error('请选择门店');
                    return
                }
                if (this.form.category.replace(/\s*/g, "") == "") {
                    this.$message.error('请选择服务类型');
                    return
                }
//                this.dialogVisible = false
                this.save()
            },

            async save() {
                var user = this.$store.getters.getUser

                try {
                    var paramStr = "client_id" + user.client_id
                        + "&client_secret=" + user.client_secret
                        + "&service_id=" + user.service_id
                        + "&username=" + user.username
                        + "&tenant_id=" + user.tenant_id
                        + "&token=" + user.token
                        + "&data={"
                        + "\"tenant_id\":\"" + user.tenant_id + "\","
                        + "\"store_id\":\"" + this.form.store + "\","
                        + "\"account_id\":\"" + this.form.account + "\","
                        + "\"cc_list\":["

                    if (this.form.ccUser) {
                        for (var i = 0; i < this.form.ccUser.length; i++) {
                            var user_id = this.form.ccUser[i]
                            if (i == 0) {
                                paramStr = paramStr + "{\"tenant_id\":\"" + user.tenant_id + "\", \"user_id\":\"" + user_id + "\"} ";
                            }
                            else {
                                paramStr = paramStr + ", {\"tenant_id\":\"" + user.tenant_id + "\", \"user_id\":\"" + user_id + "\"} ";
                            }

                        }
                    }

                    paramStr = paramStr + "], "
                    //+ "\"cc_list\":[{\"tenant_id\":\"5260785282\",\"user_id\":\"5285548854\"}],"
                    paramStr += "\"service_worker\":\"" + this.form.worker + "\","
                        + "\"count_down\":\"" + this.form.count_down + "\","
                        + "\"created_by\":\"" + user.user_id + "\","
                        + "\"ticket_no\":\"" + this.form.ticketNo + "\","
                        + "\"contents\":"
                        + "{"
                        + "\"title\":\"" + this.form.title + "\","
                        + "\"comments\":\"" + this.form.comments + "\","
                        + "\"date\":\"" + new Date(this.form.date).Format('yyyy-MM-dd') + "\","
                        + "\"phone\":\"" + this.form.phone + "\","
                        + "\"key\":\"" + this.form.category + "\","
                        + "\"account_id\":\"" + this.form.account + "\","
                        + "\"service_worker\":\"" + this.form.worker + "\","
                        + "\"photos\":[";


                    if (this.form.picArray) {
                        for (var i = 0; i < this.form.picArray.length; i++) {
                            var s3filename = this.form.picArray[i]
                            if (i == 0) {
                                paramStr = paramStr + "\"" + s3filename + "\"";
                            }
                            else {
                                paramStr = paramStr + ",\"" + s3filename + "\"";
                            }

                        }
                    }

                    paramStr = paramStr + "]"
                        + "}"
                        + "}";


                    await http.post('https://api.concierge24x7.cn:16079/wapi/order/saveOrde', paramStr).then(res => {


                        if (res.success) {
                            this.handleQueryClick()
                            this.cancelClick()
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        else {
                            this.$message.error(res.message);
                        }
                        this.loading = false
                    })


                }
                catch (err) {
                    this.error()
                }
            },
            cancelClick() {
                this.form.title = ""
                this.form.date = ""
                this.form.ticketNo = ""
                this.form.worker = ""
                this.form.comments = ""
                this.form.phone = ""
                this.form.store = ""
                this.form.category = ""
                this.form.account = ""
                this.form.count_down = ""
                this.fileList = []
                this.form.picArray = []
                this.dialogVisible = false

            },

            async getServiceTypeData() {
                var obj = this.$store.getters.getUser

                try {
                    let data = {
                        tenant_id: obj.tenant_id
                    }


                    await http.post('/wapi/v1/getServiceTypeData', data).then(res => {

                        if (res.success) {
                            this.form.categoryArray = []

                            for (var i = 0; i < res.data.length; i++) {
                                var dic = res.data[i]
                                var obj = {}
                                obj.key = dic.key
                                obj.value1 = dic.value1
                                this.form.categoryArray.push(obj)
                            }
                        }
                    })
                }
                catch (err) {
                    this.error()
                }
            },
            async getServiceWorkerData() {
                var obj = this.$store.getters.getUser
                this.form.accountArray = []

                try {
                    let data = {
                        tenant_id: obj.tenant_id,
                        user_id: obj.user_id,
                        worker_type: this.ticketEmployee == true ? "EMPLOYEE" : "",
                        worker_type2: this.ticketOutsourcing == true ? "OUTSOURCING" : ""
                    }

                    await http.post('/wapi/v1/getServiceWorkerData', data).then(res => {

                        if (res.success) {

                            for (var i = 0; i < res.data.length; i++) {
                                var dic = res.data[i]
                                var obj = {}
                                obj.worker_id = dic.user_id
                                obj.worker_type_name = dic.worker_type_name
                                this.form.workerArray.push(obj)
                            }
                        }
                        this.getStoreData(this.form.account)
                    })
                }
                catch (err) {
                    this.error()
                }
            },
            async getTicketNo() {

                var obj = this.$store.getters.getUser

                try {

                    let data = {
                        tenant_id: obj.tenant_id
                    }
                    await http.post('/wapi/v1/getTicketNo', data).then(res => {
                        if (res.success) {
                            this.form.ticketNo = res.data[0].nextval
                        }
                    })
                }
                catch (err) {
                    this.error()
                }
            },
            async getAccountData() {
                var obj = this.$store.getters.getUser

                try {
                    let data = {
                        tenant_id: obj.tenant_id
                    }

                    await http.post('/wapi/v1/getAccountData', data).then(res => {

                        if (res.success) {
                            this.form.accountArray = []

                            for (var i = 0; i < res.data.length; i++) {
                                var dic = res.data[i]
//                                if (i == 0) {
//                                    this.form2.account = dic.account_id
//                                }
                                var obj = {}
                                obj.account_id = dic.account_id
                                obj.account_name = dic.account_name
                                this.form.accountArray.push(obj)
                            }
                        }
                        this.getStoreData(this.form.account)
                    })
                }
                catch (err) {
                    this.error()
                }
            },
            handleAccountClick() {
                this.getStoreData(this.form.account)
            },
            async getStoreData(account_id) {
                var obj = this.$store.getters.getUser
                this.form.store = ""
                try {
                    let data = {
                        tenant_id: obj.tenant_id,
                        user_id: obj.user_id,
                        account_id: account_id
                    }

                    await http.post('/wapi/v1/getStoreData', data).then(res => {

                        if (res.success) {
                            this.form.storeArray = []

                            for (var i = 0; i < res.data.length; i++) {

                                var dic = res.data[i]
                                var obj = {}
                                obj.store_id = dic.store_id
                                obj.store_name = dic.store_name
                                this.form.storeArray.push(obj)
                            }
                        }
                    })
                }
                catch (err) {
                    this.error()
                }
            },

            uploadFun(param) {
                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', 'CLIENT');
                data.append('reference_id', 'com.saasyun.android');
                data.append('credential', '58f09f86-694c-472d-bb63-64f9be093fd2');
                data.append('username', this.$store.getters.getUser.username);
                data.append('tenant_id', this.$store.getters.getUser.tenant_id);
                data.append('user_id', this.$store.getters.getUser.user_id);
                data.append('category', 'USER');
                data.append('size', '300');

                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头
                http.post(param.action, data, config)//
                    .then(response => {
                        if (response.success) {
                            var s3filename = response.data.s3filename
                            this.form.picArray.push(s3filename)
                        }
                    })
                    .catch(({err}) => {
                        this.lengthoading = false
                    })
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
                var s3filename = file.response.data.s3filename
                this.form.picArray.remove(s3filename);
            },
            handlePictureCardPreview(file) {
                this.$emit('showImageAction', {
                    showImageUrl : file.url,
                    showImage : true
                })
            },
            // 上传图片成功
            handleImgSuccess(res, file) {

                if (res.success) {

                } else {
                    this.error(res.message)
                }
            },
            // 上传图片前的验证
            beforeImgUpload(file) {

                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
//                const isLt20M = file.size / 1024 / 1024 < 20

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
//                if (!isLt20M) {
//                    this.error('上传图片大小不能超过 20MB!')
//                }
                return isPic
            },

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';


</style>
<style scoped>

    .subjectList > > > .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/dialog/addThird.vue